import { Icon } from '@sakhtar/design-system/react';
import type { KpiItem } from '../types.js';

export interface KpiRowProps {
  readonly items: readonly KpiItem[];
}

/** Component 2 — KPI row with up / down deltas (values are preformatted display strings). */
export function KpiRow({ items }: KpiRowProps) {
  return (
    <div className="ai-block ai-kpis" role="list">
      {items.map((item) => (
        <div key={item.id} className="ai-kpi" role="listitem">
          <span className="ai-kpi__label">{item.label}</span>
          <span className="ai-kpi__value sk-num">{item.value}</span>
          {item.delta ? (
            <span className={`sk-kpi__delta sk-kpi__delta--${item.delta.direction}`}>
              <Icon name={item.delta.direction === 'up' ? 'arrowUp' : 'arrowDown'} size="sm" />
              <span className="sk-num">{item.delta.value}</span>
              {item.delta.caption ? (
                <span className="ai-kpi__caption">{item.delta.caption}</span>
              ) : null}
            </span>
          ) : null}
          {item.hint ? <span className="ai-kpi__caption">{item.hint}</span> : null}
        </div>
      ))}
    </div>
  );
}
